import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    title: 'Bitget Wallet',
    tooltip: 'Available only for mainnet',
  },
};
